import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex justify-between w-full container items-center mx-auto py-3" }
const _hoisted_2 = {
  id: "logo-section",
  class: /*#__PURE__*/_normalizeClass(`cursor-pointer max-w-fit w-12/12 sm:w-10/12 lg:w-2/12`)
}
const _hoisted_3 = {
  key: 0,
  id: "items-logged-section",
  class: "hidden max-w-lg w-6/12 lg:hidden xl:flex items-end justify-center -mb-2"
}
const _hoisted_4 = {
  id: "dropdown-section",
  class: "flex justify-end max-w-fit w-2/12"
}
const _hoisted_5 = {
  key: 0,
  id: "logged-items",
  class: "hidden sm:hidden lg:hidden xl:flex items-center"
}
const _hoisted_6 = { class: "flex gap-3 items-center w-40" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 1,
  id: "not-logged-items",
  class: "flex gap-4 items-center justify-end scale-90 lg:scale-100 w-full"
}
const _hoisted_10 = { class: "text-[14px] sm:text-[18px]" }
const _hoisted_11 = {
  key: 1,
  id: "dropdown-section-mobile",
  class: "flex items-center justify-between sm:flex lg:flex xl:hidden",
  "aria-controls": "top-nav",
  "aria-expanded": "false",
  "data-collapse-toggle": "top-nav"
}
const _hoisted_12 = { class: "flex gap-4" }
const _hoisted_13 = { class: "flex gap-1 items-center w-8 h-8" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 0,
  id: "not-logged-items",
  class: "flex gap-4"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "flex flex-col justify-center w-full gap-x-5" }
const _hoisted_18 = { class: "flex gap-2 items-center p-3 mb-4 text-h-primary-500" }
const _hoisted_19 = { class: "font-[700]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_ItemsNav = _resolveComponent("ItemsNav")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", {
      class: _normalizeClass(`
    ${_ctx.navColor(_ctx.actualUser?.role)}
    ${_ctx.meta.topbarCollapse() ? ' md:fixed' : ' '}
    flex justify-center gap-3 px-4 border-gray-200 dark:bg-gray-900 sticky w-full z-50 top-0 left-0 shadow-sm`)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createVNode(_component_Logo)
        ]),
        (_ctx.isLogged)
          ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
              _createVNode(_component_ItemsNav, {
                role: _ctx.actualUser?.role
              }, null, 8, ["role"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("section", _hoisted_4, [
          (_ctx.isLogged)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    class: "rounded-full object-cover w-12 h-12 bg-gray-50",
                    src: 
                _ctx.actualUser?.photoProfile || require('@/assets/images/user.svg')
              ,
                    onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.imgDefaultError && _ctx.imgDefaultError(...args))),
                    alt: "user"
                  }, null, 40, _hoisted_7),
                  _createElementVNode("p", {
                    class: "btn-simple w-32 truncate cursor-pointer capitalize",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
                    "aria-haspopup": "true",
                    "aria-controls": "overlay_menu",
                    title: _ctx.actualUser?.firstName
                  }, _toDisplayString(_ctx.actualUser?.firstName), 9, _hoisted_8)
                ]),
                _createVNode(_component_Menu, {
                  id: "overlay_menu",
                  ref: "menu",
                  model: _ctx.loggedDropdownItems(),
                  popup: true
                }, null, 8, ["model"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isLogged)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unloggedItems, (item, i) => {
                  return (_openBlock(), _createElementBlock("ul", { key: i }, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_Button, {
                        id: 'btn-' + i,
                        class: _normalizeClass(`${item.isBtn ? 'btn-primary' : 'btn-simple'} truncate`),
                        onClick: ($event: any) => (_ctx.go.redirectToPage(item.link))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h6", _hoisted_10, _toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["id", "class", "onClick"])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isLogged)
          ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("img", {
                    class: "rounded-full object-cover w-8 h-8 cursor-pointer",
                    src: 
                _ctx.actualUser?.photoProfile || require('@/assets/images/user.svg')
              ,
                    onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.imgDefaultError && _ctx.imgDefaultError(...args))),
                    alt: "user",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
                  }, null, 40, _hoisted_14)
                ]),
                _createVNode(_component_Menu, {
                  id: "overlay_menu",
                  ref: "menu",
                  model: _ctx.loggedDropdownItems(),
                  popup: true
                }, null, 8, ["model"])
              ]),
              _createVNode(_component_Button, {
                icon: "pi pi-align-right",
                class: "btn-simple",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSidebar = true))
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createVNode(_component_Sidebar, {
      visible: _ctx.showSidebar,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showSidebar) = $event)),
      baseZIndex: 10000,
      position: "right"
    }, {
      default: _withCtx(() => [
        (!_ctx.isLogged)
          ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unloggedItems, (item, i) => {
                return (_openBlock(), _createElementBlock("ul", { key: i }, [
                  _createVNode(_component_Button, {
                    label: item.name,
                    class: _normalizeClass(item.isBtn ? 'btn-primary' : 'btn-simple'),
                    onClick: ($event: any) => (_ctx.go.redirectToPage(item.link))
                  }, null, 8, ["label", "class", "onClick"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.isLogged)
          ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_v_icon, {
                    name: "hi-solid-user-circle",
                    scale: 1.2
                  }, null, 8, ["scale"]),
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.firstUsername(_ctx.actualUser?.userName)), 1)
                ]),
                _createVNode(_component_ItemsNav, {
                  role: _ctx.actualUser?.role,
                  isMobile: true
                }, null, 8, ["role"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}